import { collectedAtVenueRows } from "./collectedAtVenue";
import { hostEarningsRows } from "./hostEarnings";
import { paymentPayoutRows } from "./paymentPayout";
import { priceBreakdownRows } from "./priceBreakdown";

/**
 * Single canonical table: declaration order + `show` predicates.
 * Never reorder per booking type.
 */
const PRICE_ROWS = [
  ...priceBreakdownRows,
  ...hostEarningsRows,
  ...paymentPayoutRows,
  ...collectedAtVenueRows,
];

export { PRICE_ROWS };
